<template>
  <ArchivedUsersDataTable />
</template>
<script>
import ArchivedUsersDataTable from "@/v3components/Datatables/ArchivedUsersDataTable.vue"

export default {
  name: "ArchivedUsers",
  components: { ArchivedUsersDataTable }
}
</script>
